import { all } from 'redux-saga/effects'
import user from './user/sagas'
import menu from './menu/sagas'
import appsettings from './appsettings/sagas'
import settings from './settings/sagas'
import etc from './etc/sagas'
import maintenance from './maintenance/sagas'

export default function* rootSaga() {
  yield all([user(), menu(), appsettings(), settings(), etc(), maintenance()])
}
